import Vue, { PropType } from 'vue';
import IconBase from '../icon';
import { IconProps, SVGJson } from '../utils/types';
import useSizeProps from '../utils/use-size-props';

const element: SVGJson = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"g","attrs":{"id":"ai-edit"},"children":[{"tag":"path","attrs":{"id":"fill1","fill":"props.fillColor1","d":"M21 6.5L10.001 17.5L10 17.499L7.58594 19.9141C7.21088 20.289 6.70222 20.5 6.17188 20.5H2.5V16.8281C2.50009 16.2979 2.71107 15.789 3.08594 15.4141L16.5 2L21 6.5Z"}},{"tag":"path","attrs":{"id":"stroke1","stroke":"props.strokeColor1","d":"M10.0007 17.4995L5.50073 12.9995M10.0007 17.4995L7.58653 19.9139C7.21145 20.289 6.70272 20.4998 6.17226 20.4998H2.5L2.5006 16.8277C2.50068 16.2974 2.71139 15.7889 3.08638 15.4139L5.50073 12.9995M10.0007 17.4995L21.0007 6.49951L16.5007 1.99951L5.50073 12.9995","strokeWidth":"props.strokeWidth"}},{"tag":"g","attrs":{"id":"stroke2"},"children":[{"tag":"path","attrs":{"stroke":"props.strokeColor2","d":"M5 3L5.33234 3.66766L6 4L5.33234 4.33234L5 5L4.66766 4.33234L4 4L4.66766 3.66766L5 3Z","strokeWidth":"props.strokeWidth"}},{"tag":"path","attrs":{"stroke":"props.strokeColor2","d":"M19 16.75L19.7 18.3L21.25 19L19.7 19.7L19 21.25L18.3 19.7L16.75 19L18.3 18.3L19 16.75Z","strokeWidth":"props.strokeWidth"}}]}]}]};

const AiEdit = Vue.extend<IconProps>({
  name: 'AiEditIcon',
  functional: true,
  props: {
    size: {
      type: String,
    },
    onClick: {
      type: Function as PropType<IconProps['onClick']>,
    },
    fillColor: {
      type: [String, Array] as PropType<IconProps['fillColor']>,
    },
    strokeColor: {
      type: [String, Array] as PropType<IconProps['fillColor']>,
    },
    strokeWidth: {
      type: Number,
      default: 2
    }
  },
  render(createElement, context) {
    const { props, data } = context;
    const { size, ...otherProps } = props;

    const { className, style } = useSizeProps(size);
    const fullProps = {
      ...otherProps || {},
      id: 'ai-edit',
      icon: element,
      staticClass: className,
      style,
    };
    data.props = fullProps;
    return createElement(IconBase, data);
  },
});

export default AiEdit;
